module.exports = __webpack_public_path__ + "img/top-3-3.7c222883.jpg";